// @ts-nocheck

import { css } from 'styled-components';

import { SportIds } from '../../../types/sports';

export const LINE_UP_MODAL_APPEARANCE_TRANSITION_DURATION = 300; // ms

type LineUpFieldBySportIdType = {
  playerRowJustifyContent: string;
  wrapperPadding: number;
  innerPadding: number;
  sidePadding: number;
  topOffset: number;
  topPadding: number;
  bottomPadding: number;
  wrapperTopPadding?: number;
};

export const LineUpFieldBySportId: Record<SportId, LineUpFieldBySportIdType> = new Proxy(
  {
    [SportIds.BASKETBALL]: {
      playerRowJustifyContent: 'space-between',
      wrapperPadding: 1.5, // em
      innerPadding: 0.9, // em
      sidePadding: 1, // em
      topOffset: 4, // em
      topPadding: 3.6, // em
      bottomPadding: 0.4, // em
    },
    [SportIds.ICEHOCKEY]: {
      playerRowJustifyContent: 'space-between',
      wrapperTopPadding: 2.5, // em
      wrapperPadding: 1.4, // em
      innerPadding: 0.4, // em
      sidePadding: 1, // em
      topOffset: 0, // em
      topPadding: 0.8, // em
      bottomPadding: 3.7, // em
    },
    default: {
      playerRowJustifyContent: 'space-around',
      wrapperPadding: 1, // em
      innerPadding: 0, // em
      sidePadding: 1, // em
      topOffset: 3, // em
      topPadding: 3, // em
      bottomPadding: 0, // em
    },
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return origin.default;
      }
      return origin[key];
    },
  },
);

export const LineUpMainViewStyleBySportId: Record<SportId, ThemedCssFunction> = new Proxy(
  {
    [SportIds.SOCCER]: css`
      --LineUpMainView-backgroundPosition: 50% 4.5em;
      --LineUpMainView-mobileBackgroundPosition: 50% 12.5em;
      --LineUpMainView-desktopFieldWidth: 83%;
      --LineUpMainView-desktopFontSize: 100%;
      --LineUpMainView-backgroundSize: 115%;
      --LineUpMainView-mobileBackgroundSize: 115%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #0a1034 75%, #070d1d 98%, #000 100%);
    `,
    [SportIds.RUGBY]: css`
      --LineUpMainView-backgroundPosition: 50% 1em;
      --LineUpMainView-mobileBackgroundPosition: 50% 11.5em;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 115%;
      --LineUpMainView-mobileBackgroundSize: 115%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #0a1034 75%, #070d1d 98%, #000 100%);
    `,
    [SportIds.RUGBY_LEAGUE]: css`
      --LineUpMainView-backgroundPosition: 50% 1em;
      --LineUpMainView-mobileBackgroundPosition: 50% 11.5em;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 115%;
      --LineUpMainView-mobileBackgroundSize: 115%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #0a1034 75%, #070d1d 98%, #000 100%);
    `,
    [SportIds.BASKETBALL]: css`
      --LineUpMainView-backgroundPosition: 50% -1em;
      --LineUpMainView-mobileBackgroundPosition: 50% 5em;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 100%;
      --LineUpMainView-mobileBackgroundSize: 116%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #0a1034 75%, #070d1d 98%, #000 100%);
    `,
    [SportIds.ICEHOCKEY]: css`
      --LineUpMainView-backgroundPosition: 50% 4.5em;
      --LineUpMainView-mobileBackgroundPosition: 50% 6em;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 115%;
      --LineUpMainView-mobileBackgroundSize: 120%;
      --LineUpMainView-backgroundGradient: linear-gradient(
        to bottom,
        #060b13,
        #0c1841 40%,
        #152e79 47%,
        rgba(0, 61, 219) 60%,
        #000 61%,
        #000 100%
      );
    `,
    [SportIds.FORMULA_1]: css`
      --LineUpMainView-backgroundPosition: center 0px;
      --LineUpMainView-mobileBackgroundPosition: center -14.5%;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 100%;
      --LineUpMainView-mobileBackgroundSize: 100%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #000 100%);
    `,
    [SportIds.MOTO]: css`
      --LineUpMainView-backgroundPosition: center 0px;
      --LineUpMainView-mobileBackgroundPosition: center -14.5%;
      --LineUpMainView-desktopFieldWidth: 75%;
      --LineUpMainView-desktopFontSize: 90%;
      --LineUpMainView-backgroundSize: 100%;
      --LineUpMainView-mobileBackgroundSize: 100%;
      --LineUpMainView-backgroundGradient: linear-gradient(0deg, #000 0%, #000 100%);
    `,
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return origin[SportIds.SOCCER];
      }
      return origin[key];
    },
  },
);

type LineUpInfoBySportIdType = {
  yOffset: number;
  maxWidth: number;
};

export const LineUpInfoBySportId: Record<SportId, LineUpInfoBySportIdType> = new Proxy(
  {
    [SportIds.BASKETBALL]: {
      yOffset: 2, // em
      maxWidth: 5, // em
    },
    [SportIds.ICEHOCKEY]: {
      yOffset: 1.6, // em
      maxWidth: 15, // em
    },
    default: {
      yOffset: 0, // em
      maxWidth: 5, // em
    },
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return origin.default;
      }

      return origin[key];
    },
  },
);

export const LineUpSportsWithStopWatchIcon: Array<SportId> = [SportIds.FORMULA_1, SportIds.MOTO];

type LineUpRaceTrackBySportIdType = {
  carsWrapperPadding: string;
  lineMarginTop: number;
  positionIndicatorTop: number;
  positionIndicatorLeft: number;
  imgMargin?: string;
  imgTransform?: string;
};

export const LineUpRaceTrackBySportId = new Proxy<Partial<Record<SportId, LineUpRaceTrackBySportIdType>>>(
  {
    [SportIds.FORMULA_1]: {
      carsWrapperPadding: '0 19%',
      lineMarginTop: 30, // px
      positionIndicatorTop: 0.6, // em
      positionIndicatorLeft: 3.75, // em
      imgMargin: undefined,
      imgTransform: 'rotate(-90deg)',
    },
    [SportIds.MOTO]: {
      carsWrapperPadding: '0 7%',
      lineMarginTop: 20, // px
      positionIndicatorTop: 0, // em
      positionIndicatorLeft: 3.5, // em
      imgMargin: '0.5em 0 -0.5em',
      imgTransform: undefined,
    },
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return origin[SportIds.FORMULA_1];
      }
      return origin[key];
    },
  },
);
